import { render } from "./BaseTableFull.vue?vue&type=template&id=d6c4a96c"
import script from "./BaseTableFull.vue?vue&type=script&lang=js"
export * from "./BaseTableFull.vue?vue&type=script&lang=js"

import exportComponent from "/Users/norman/Code/aerocle-project/aerocle_client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__